import { gql } from '@apollo/client';

export const CURRENT_USER_RESOURCE_CODES = gql`
  query CurrentUserResourceCodes {
    currentUserResourceCodes
  }
`;
